import {
  HINDU_D, HINDU_FRONT_W, HINDU_ISO_DX, HINDU_ISO_DY,
} from "./hinduGeom.js";

type Props = {
  layers: number;
  x: number;
  y: number;
};

export function HinduPile({ layers, x, y }: Props) {
  if (layers <= 0) return null;
  const w = HINDU_FRONT_W;
  const h = layers * HINDU_D;
  const dx = HINDU_ISO_DX;
  const dy = HINDU_ISO_DY;
  const x0 = x;
  const y0 = y - h;
  const stripes = [];
  for (let i = 1; i < layers; i += 1) {
    const ly = y0 + i * HINDU_D;
    stripes.push(
      <line key={`f-${i}`} x1={x0} y1={ly} x2={x0 + w} y2={ly} />,
      <line key={`s-${i}`} x1={x0 + w} y1={ly} x2={x0 + w + dx} y2={ly + dy} />,
    );
  }
  return (
    <g className="hindu-pile">
      <polygon points={`${x0 + w},${y0} ${x0 + w + dx},${y0 + dy} ${x0 + w + dx},${y0 + h + dy} ${x0 + w},${y0 + h}`} />
      <polygon points={`${x0},${y0} ${x0 + w},${y0} ${x0 + w},${y0 + h} ${x0},${y0 + h}`} />
      <polygon points={`${x0},${y0} ${x0 + w},${y0} ${x0 + w + dx},${y0 + dy} ${x0 + dx},${y0 + dy}`} />
      {stripes}
    </g>
  );
}

export function hinduSilhouette(x: number, y: number, layers: number) {
  const w = HINDU_FRONT_W;
  const h = layers * HINDU_D;
  const dx = HINDU_ISO_DX;
  const dy = HINDU_ISO_DY;
  const x0 = x;
  const y0 = y - h;
  return `M${x0},${y0 + h} L${x0},${y0} L${x0 + dx},${y0 + dy} L${x0 + w + dx},${y0 + dy} L${x0 + w + dx},${y0 + h + dy} L${x0 + w},${y0 + h} Z`;
}
